module.exports = __webpack_public_path__ + "static/media/favicon.6ccd92ab.ico";